import { euclideanDivision } from "../numbers/utils";

/**
 * Converts a time in milliseconds to a human readable duration.
 */
export function convertTimeToHumanDuration(duration: number): string {
  const milliseconds = Math.floor((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  const hoursStr = hours < 10 ? "0" + hours : hours;
  const minutesStr = minutes < 10 ? "0" + minutes : minutes;
  const secondsStr = seconds < 10 ? "0" + seconds : seconds;

  return hoursStr + ":" + minutesStr + ":" + secondsStr + "." + milliseconds;
}

export function convertLongTimeToHumanDuration(
  duration: number,
  labels: {
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
  } = {
    days: " days ",
    hours: ":",
    minutes: ":",
    seconds: "",
  },
): string {
  const [days, daysRemainingTime] = euclideanDivision(duration, 24 * 60 * 60 * 1000);
  const [hours, hoursRemainingTime] = euclideanDivision(daysRemainingTime, 60 * 60 * 1000);
  const [minutes, minutesRemainingTime] = euclideanDivision(hoursRemainingTime, 60 * 1000);
  const [seconds] = euclideanDivision(minutesRemainingTime, 1000);

  // Format days only if they are non-zero
  const daysStr = days > 0 ? String(days).padStart(2, "0") + labels.days : "";

  const hoursStr = String(hours).padStart(2, "0") + labels.hours;
  const minutesStr = String(minutes).padStart(2, "0") + labels.minutes;
  const secondsStr = String(seconds).padStart(2, "0") + labels.seconds;

  return [daysStr, hoursStr, minutesStr, secondsStr].filter((part) => part.trim().length > 0).join("");
}
